const protocol = process.env.NODE_ENV === 'development' ? 'http' : 'https';
const dynamicHost = typeof window !== 'undefined' && window.location.host;
let staticHost = process.env.VERCEL_URL || 'localhost:3000';

if (process.env.VERCEL_ENV === 'production' || process.env.CI) {
  staticHost = 'fagmobler.no';
}

export const HOST = `${protocol}://${dynamicHost || staticHost}`;
